import Avatar from "../../components/elements/Avatar";
import { Account } from "../../components/models/account/Account";
import { getPhoneNumberFromShortCodeFormat } from "../../utilities/miscFunctions";

interface IProps {
    account: Account;
}
export default function AccountSummary(props: IProps) {
    return (
        <div className="flex flex-col justify-center items-center text-xs">
            <Avatar
                src={props.account?.customer.picture_url}
            />
            <span className="font-bold dark:text-text-dark-secondary">{props.account.name} ({props.account.accountNumber})</span>
            <span className="dark:text-text-dark-secondary"><b>Phone:</b> {getPhoneNumberFromShortCodeFormat(props.account.customer.phone)}</span>
            {/* <span><b>Location:</b> {selectedAccount.customer.address?.street_address}, {selectedAccount.customer?.address?.city}</span> */}
            {props.account.isSUSU() && (
                <>
                    <span className="dark:text-text-dark-secondary"><b>Payment Rate:</b>  ₵ {props.account.rate}</span>
                </>
            )}
            {/* <span className=""><b>Total Deposits:</b> ₵ {selectedAccount.totalDeposits}</span> */}
            <span className="bg-green-100 text-green-700 px-4"><b>Balance:</b> ₵ {props.account.computedBalance}</span>

        </div>
    )
}